<template>
    <div id="FooterBannerSection">
      <v-container class="p-0" fluid>
        <v-row no-gutters>
          <v-col cols="12">
            <p class="description">현재 {{ number }}개 상점의 사장님들과 함께하고 있습니다</p>
            <div class="box" v-inview:animate="'fadeIn'">
              <carousel
                :autoplay="true"
                :loop="true"
                :mouse-drag="true"
                :per-page="1"
                :paginationEnabled="false"
                :autoplayTimeout="4000"
                @pageChange="pageChange">
                <slide class="talk"
                       :key="index"
                       :index="index"
                       v-for="(question, index) in questions">
                  <div class="question">
                    <div class="left">
                      <div class="profile">
                        <img class="b-img" :src="require('@/assets/images/pirate/' + question.img)"/>
                      </div>
                    </div>
                    <div class="right">
                      <div class="content" v-line-clamp="2"
                           v-html="question.content">
                      </div>
                    </div>
                  </div>
                </slide>
              </carousel>
              <div class="dots-section">
                <ul class="dots">
                  <li :class="{'active': index==currentSlide}"
                      :key="index" class="dot"
                      v-for="(question, index) in questions"
                  ></li>
                </ul>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
  </div>
</template>
<script>
export default {
  name: 'FooterBannerSection',
  components: {
  },
  data() {
    return {
      currentSlide: 0,
      number: 567,
      questions: [
        {
          img: 'img-img-today-pro-1.svg',
          content: '저희 매장에 찾아주시는 손님분들이 선물 당첨됐다고 저한테 직접 자랑하시는거 보면, 좋은 기억을 남긴 것 같아 뿌듯해요.',
        },
        {
          img: 'img-img-today-pro-2.svg',
          content: '에어팟 당첨됐다며 엄청 좋아하시는 손님이 있었는데, 올때마다 QR찍으시는거 보면 괜히 흐뭇하네요.',
        },
        {
          img: 'img-img-today-pro-3.svg',
          content: '종종 오시던 손님이 갑자기 커피를 사다주시길래 뭔가했는데, 오늘의식당 통해서 당첨된거 혼자드시기 미안하다며 제꺼도 사온거라고 하시더라구요 ㅎㅎ',
        },
      ]
    }
  },
  methods: {
    pageChange(data) {
      this.currentSlide = data
    }
  }
}
</script>
<style lang="scss" scoped>
  #FooterBannerSection {
    background-color: #fcfbf9;
    padding-top: 6vh;
    padding-left: 7.82vw;
    padding-right: 7.82vw;
    padding-bottom: 20vh;
    .description {
      text-align: center;
      font-size: 0.94rem;
      letter-spacing: -0.19px;
      font-weight: 600;
    }
    .box {
      box-sizing: border-box;
      width: 100%;
      display: block;
      float: left;
      position: relative;
      border-radius: 12px;
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      margin-top: 13px;
      @media screen and (max-width: 350px) {
        padding: 24px 21px;
      }
      @media screen and (min-width: 350px) {
        padding: 27px 24px;
      }
      .left {
        width: 40px;
        float: left;
        margin-right: 10px;
      }
      .right {
        width: calc(100% - 50px);
        float: left;
      }
      .question {
        width: 100%;
        position: relative;
        display: block;
        float: left;
        .profile {
          img {
            width: 100%;
            height: 40px;
            border-radius: 100%;
            border-width: 0;
            background-color: #f6f6f6;
          }
        }
        .content {
          font-weight: 900;
          line-height: 1.4;
          height: 4em;
          white-space: normal;
          overflow: hidden;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
          @media screen and (max-width: 350px) {
            font-size: 13px;
          }
          @media screen and (min-width: 350px) {
            font-size: 15px;
          }
        }
      }
      .dots {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        list-style-type: none;
        margin: 15px 0 0 0;
        padding: 0;
        .dot {
          width: 8px;
          height: 8px;
          margin: 0px 3px;
          background-color: #d7e1ea;
          border-radius: 100%;
          &.active {
            background-color: #1baaf1;
          }
        }
      }
    }
  }
  #Banner {
    margin-top: 0;
    padding-left: 0;
    padding-right: 0;
  }
</style>
